var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "reports m" } },
    [
      _vm.noEvidenceImage ? _c("no-multi-channel-service") : _vm._e(),
      _vm._v(" "),
      !_vm.noEvidenceImage
        ? _c("div", [
            _c("div", { staticClass: "row m-t-xl" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("table", { staticClass: "table table-bordered bg-white" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "product-report-item-title" }, [
                        _vm._v("商品レポート（Amazon倉庫）")
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center product-report-item-title"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary w-254 btn-report-item-registed",
                              on: {
                                click: function($event) {
                                  _vm.openModalDownload("amazon")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  ダウンロード\n                "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "product-report-item-title" }, [
                        _vm._v("商品レポート（STOCKCREW倉庫）")
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center product-report-item-title"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary w-254 btn-report-item-registed",
                              on: {
                                click: function($event) {
                                  _vm.openModalDownload("sc")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  ダウンロード\n                "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowDownload
        ? _c("product-download", {
            attrs: { warehouseType: _vm.warehouseType },
            on: {
              close: _vm.closeModalDownload,
              download: function($event) {
                _vm.handleDownloadCsv()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d09379b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d09379b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/Reports.vue
// module id = null
// module chunks = 